module.exports = __webpack_public_path__ + "img/Russia.227e2893.svg";